import { render, staticRenderFns } from "./mailwhite-info.vue?vue&type=template&id=5f84a994&"
import script from "./mailwhite-info.vue?vue&type=script&lang=js&"
export * from "./mailwhite-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "mailwhite-info.vue"
export default component.exports